<template>
    <component
        v-bind:is="iconInstanceType"
        v-bind:class="classObj" />
</template>

<script>
    import settings from "./menuIcons/reactive/Settings.vue";
    import programadmin from "./menuIcons/reactive/ProgramAdmin.vue";
    import programdesign from "./menuIcons/reactive/ProgramDesign.vue";
    import cpradmin from "./menuIcons/reactive/CPRAdmin.vue";

    const reactiveIcons = {
        Settings: settings,
        ProgramAdmin: programadmin,
        ProgramDesign: programdesign,
        CPRAdmin: cpradmin
    };

    export default {
        props: {
            pageName: { type: String, required: false, default: null },
            menuTypeName: { type: String, required: false, default: null },
            primary: { type: Boolean, required: false, default: false }
        },
        computed: {
            classObj() {
                const classes = {};

                // Main icons
                if (this.menuTypeName && typeof this.menuTypeName === "string") {
                    classes["nav-main-icon-size"] = true;

                    // If the icon is not reactive, add the class for the background image
                    if (!this.isReactiveIcon) {
                        classes[`nav-main-${this.menuTypeName.toLowerCase()}`] = true;
                    }

                    // Sub-menu icons
                } else if (this.pageName && typeof this.pageName === "string") {
                    classes["nav-sub-icon-size"] = true;
                    classes[`nav-item-${this.pageName.toLowerCase()}-image`] = true;
                    classes["bg-primary"] = this.primary;
                    classes["bg-white"] = !this.primary;
                }

                return classes;
            },
            iconInstanceType() {
                return reactiveIcons[this.menuTypeName] ?? "div";
            },
            isReactiveIcon() {
                return reactiveIcons.hasOwnProperty(this.menuTypeName);
            }
        }
    };
</script>

<style lang="scss">
    $iconNames: (
        "Home": (),
        "ProgramDesign": (
            "AutomationList",
            "CommunicationsList",
            "Connections",
            "ContentLibrary",
            "DataFieldList",
            "DeadlineList",
            "DocumentTemplateList",
            "EditCustomIds",
            "EditProjectListColumns",
            "EditWorkflow",
            "EnvelopeList",
            "FormList",
            "FormulaList",
            "FrontPageList",
            "IncentiveDesignList",
            "Milestones",
            "ProgramChannels",
            "ProjectSummaryDesigner",
            "ProjectViewList",
            "RoleList",
            "AIPromptList",
            "EditAIPrompt"
        ),
        "ProgramAdmin": (
            "DuplicateCheck",
            "EditBusinessCalendar",
            "EditDashboard",
            "EditProgram",
            "ImportFromV2",
            "ManageEPayments",
            "OperationStatus",
            "ProgramESignatureEnvelopes",
            "ProgramInfo",
            "ProgramPayments",
            "ProgramStatistics",
            "ProjectImport",
            "ReleaseNoteList",
            "ReportList",
            "StripeConnect",
            "TopicList",
            "UsersList",
            "ThemeList",
            "EditTheme"
        ),
        "Settings": (
            "AccessGrants",
            "AddPrograms",
            "FormSense",
            "InquirySummary",
            "ManageAccount"
        ),
        "CPRAdmin": (
            "AdvancedProgramInfo",
            "AgencyList",
            "AgencyStatistics",
            "DataExtractors",
            "ESignatureAdminClassic",
            "Maintenance",
            "ManageAPIKeys",
            "ObservableOperations",
            "OrganizationList",
            "ProgramDesignAuditLog",
            "ProgramDesignComponents",
            "ProgramList",
            "ProjectExport",
            "ResponsiveTestBench",
            "SupportAssistant",
            "SynchronizePvComponents",
            "UserMasterList",
            "SSOProviders"
        ),
        "Organization": (
            "CreateOrganization",
            "OrganizationInvitationResponse",
            "ManageOrganization",
            "ManageOrganizationMember"
        )
    );

    $main-icon-size: 24px;
    $item-icon-size: 22px;

    .nav-main-icon-size {
        height: $main-icon-size;
        width: $main-icon-size;
    }

    .nav-sub-icon-size {
        height: $item-icon-size;
        width: $item-icon-size;
    }

    @each $main, $subItems in $iconNames {
        // This class only applies to the Home icon after render,
        // but the placeholder element on the cshtml sidebar need
        // the rules for other icons to exist before the bundles load.
        .nav-main-#{to-lower-case($main)} {
            background-image: url("./menuIcons/#{$main}.svg");
            background-size: 100% 100%;
        }

        @if length($subItems) > 0 {
            @each $item in $subItems {
                .nav-item-#{to-lower-case($item)}-image {
                    mask-image: url("./menuIcons/#{$main}/#{$item}.svg");
                    mask-size: 100% 100%;
                }
            }
        }
    }
</style>
